import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CTA, Text } from '../../../ui/atoms';
import ButtonsBanner from '../../../ui/components/Tutor/ButtonsBanner';
import { MODAL_OPEN } from '../../redux/actions';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { GROUP_LIST_GET } from '../../redux/actions/tutors';
import { timestampToDate } from '../../../utils/common';
import {
  Legend,
  GroupCard,
  RegistrationWrapper,
} from '../../../ui/components/Tutor/Registration/style';
import { CustomBox, Separator } from './style';
import InputLegend from '../../../ui/atoms/InputLegend';
import { InnerBox } from '../../../ui/components/Tutor/style';
import ModalConfirm, {
  ModalConfirmId,
} from '../../../ui/atoms/Modals/ModalConfirm';
import ModalRejectRequest, {
  ModalRejectRequestId,
} from '../../../ui/atoms/Modals/ModalRejectRequest';
import ModalUsersGroup, {
  ModalUsersGroupId,
} from '../../../ui/atoms/Modals/ModalUsersGroup';
import { APPROVAL_STATUS_SET } from '../../redux/actions/eventApproval';

const Registration = ({
  mediaIsPhone,
  editDetails,
  groups,
  getGroups,
  modalOpen,
  approvalStatusSet,
}) => {
  const navigate = useNavigate();
  const [addedGroupIds, setAddedGroupIds] = useState([]);

  useEffect(() => {
    getGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (editDetails?.included_groups?.length > 0) {
      setAddedGroupIds(
        editDetails.included_groups.map((g) => g.id?.toString())
      );
    }
  }, [editDetails]);

  return (
    <>
      <RegistrationWrapper>
        <Text type="b3" mb={24}>
          Sezione dedicata alle iscrizioni degli utenti al percorso formativo
          che si sta creando
        </Text>
        <CustomBox>
          <Text type="h2" mb={24}>
            Iscrizione utenti discenti
          </Text>
          <InputLegend label="Obbligatorietà" mb={8} />
          <Text type="b3" mb={24}>
            <p>
              {(editDetails?.mandatory_ffoo || []).map((fo, i) => (
                <span key={`fo-${fo?.id}`}>
                  {i > 0 ? ', ' : ''}
                  {fo?.name}
                </span>
              ))}
            </p>
          </Text>
          {addedGroupIds?.length > 0 && (
            <>
              <Separator />
              <InnerBox>
                <Text type="h2" mb={32}>
                  Gruppi iscritti
                </Text>
                <Text type="b4" mb={24}>
                  {addedGroupIds?.length || 0} Gruppi aggiunti
                </Text>
                {!mediaIsPhone && (
                  <Legend>
                    <Text type="h3.5">nome gruppo</Text>
                    <Text type="h3.5">numero utenti</Text>
                    <Text type="h3.5">DATA DI CREAZIONE</Text>
                  </Legend>
                )}
                {(groups || [])
                  .filter((g) => addedGroupIds?.includes(g?.id?.toString()))
                  .map((g) => {
                    if (mediaIsPhone) {
                      return (
                        <GroupCard key={g.id}>
                          <Text type="h5">nome gruppo</Text>
                          <Text type="h3">{g.name}</Text>
                          <Text type="h5">numero utenti</Text>
                          <Text type="b4">{g.total_users} utenti</Text>
                          <Text type="h5">DATA DI CREAZIONE</Text>
                          <Text type="b4">
                            {timestampToDate(g.creation_date)}
                          </Text>
                          <div />
                          <CTA
                            type="tertiary"
                            btnText="Visualizza"
                            icon="eye"
                            onClick={() => {
                              modalOpen(ModalUsersGroupId, { group_id: g.id });
                            }}
                            bottomRight
                          />
                        </GroupCard>
                      );
                    }
                    return (
                      <GroupCard key={g.id}>
                        <Text type="h3">{g.name}</Text>
                        <Text type="b4">{g.total_users} utenti</Text>
                        <Text type="b4">
                          {timestampToDate(g.creation_date)}
                        </Text>
                        <div className="d-flex g-48 btns-wrapper">
                          <CTA
                            type="tertiary"
                            btnText="Visualizza"
                            icon="eye"
                            onClick={() => {
                              modalOpen(ModalUsersGroupId, { group_id: g.id });
                            }}
                          />
                        </div>
                      </GroupCard>
                    );
                  })}
              </InnerBox>
            </>
          )}
        </CustomBox>
      </RegistrationWrapper>
      <ButtonsBanner>
        <div className="btns-wrapper">
          <CTA
            fullsize
            type="secondary"
            btnText="Rifiuta"
            onClick={() => {
              modalOpen(ModalRejectRequestId);
            }}
          />
          <CTA
            fullsize={mediaIsPhone}
            btnText="Approva"
            onClick={() => {
              modalOpen(ModalConfirmId);
            }}
          />
        </div>
      </ButtonsBanner>
      <ModalRejectRequest
        onClick={(comment) => {
          approvalStatusSet({
            id: editDetails?.id,
            body: {
              status: 'REJECTED',
              comment,
            },
            navigate,
          });
        }}
      />
      <ModalConfirm
        title="Approva la richiesta"
        onClick={() => {
          approvalStatusSet({
            id: editDetails?.id,
            body: {
              status: 'APPROVED',
            },
            navigate,
          });
        }}
      >
        <Text type="h3" mb={16}>
          Stai approvando la richiesta per la creazione del percorso formativo
          evento “{editDetails?.title}”
        </Text>
        <Text type="b4" mb={40}>
          Cliccando su “conferma” procedi ad approvare la richiesta inviata dal
          tutor.
        </Text>
      </ModalConfirm>
      <ModalUsersGroup />
    </>
  );
};

Registration.propTypes = {
  mediaIsPhone: PropTypes.bool,
  // HOC: state
  groups: PropTypes.array,
  editDetails: PropTypes.object,
  // HOC: dispatch
  getGroups: PropTypes.func,
  modalOpen: PropTypes.func,
  approvalStatusSet: PropTypes.func,
};

export default connect(
  (state) => {
    const {
      groups: { list: groups },
    } = state.tutors;
    const { details: editDetails } = state.tutorCourseList;
    return { groups, editDetails };
  },
  (dispatch) => ({
    modalOpen: (id, payload = {}) =>
      dispatch({ type: MODAL_OPEN, id, payload }),
    getGroups: () => dispatch({ type: GROUP_LIST_GET._REQUEST }),
    approvalStatusSet: ({ id, body, navigate }) =>
      dispatch({ type: APPROVAL_STATUS_SET._REQUEST, id, body, navigate }),
  })
)(withMediaQueries(Registration));
